import { Component, OnInit, inject } from "@angular/core";
import { NavigationService } from "../../services/navigation/navigation.service";
import { AuthenticationService } from "../authentication.service";

@Component({
    selector: "app-not-authorized",
    templateUrl: "./not-authorized.component.html",
    styleUrls: ["./not-authorized.component.scss"],
    standalone: false
})
export class NotAuthorizedComponent implements OnInit {
  private authService = inject(AuthenticationService);
  private navService = inject(NavigationService);


  ngOnInit(): void {
    setTimeout(async () => {
      if (this.authService.userIsLoggedIn()) {
        await this.navService.GoToStartPage();
      } else {
        await this.navService.GoToLoginPage();
      }
    }, 3000);
  }
}
